export default "__VITE_ASSET__CAdPGpPT__"